import { getOnOffConfigOrElse } from '../providers/config/config.service';

export function isToggleConsentGeolocEnabled(): boolean {
  return getOnOffConfigOrElse('TOGGLE_CONSENTEMENT_GEOLOC', 'OFF') === 'ON';
}

export function isTogglePtiButtonSOSEnabled(): boolean {
  return getOnOffConfigOrElse('TOGGLE_PTI_BUTTON_SOS', 'OFF') === 'ON';
}

export function isTogglePasswordExpiryEnabled(): boolean {
  return getOnOffConfigOrElse('TOGGLE_PASSWORD_EXPIRY', 'OFF') === 'ON';
}

export function isToggleTopInterventionEnabled(): boolean {
  return getOnOffConfigOrElse('TOGGLE_TOP_INTERVENTION', 'OFF') === 'ON';
}

export function isTogglePortefeuillePerimetreIsoleEnabled(): boolean {
  return getOnOffConfigOrElse('TOGGLE_PORTEFEUILLE_PERIMETRE_ISOLE', 'OFF') === 'ON';
}

export function isToggleGestionStocksEnabled(): boolean {
  return getOnOffConfigOrElse('GESTION_STOCKS', 'OFF') === 'ON';
}
